import React, {useEffect} from 'react';
import {format, toDate, lightFormat, endOfMonth, getDate, parseISO, parse} from 'date-fns';
import {StatusTag} from '../Styled/Styled.styles';
import {DataTable} from './Table.styles';

const Table = ({data, onActionBtnClick, tableData, getCommissionData}) => {
  const {month_wise_breakup: monthWiseBreakup} = tableData || [];

  const extractModalDataFromSelectedItem = item => {
    const trackDetailsObject = {};
    for (const i in item) {
      if (item[i].start_month) {
        trackDetailsObject['startMonth'] = item[i].start_month;
      }
      if (item[i].end_month) {
        trackDetailsObject['endMonth'] = item[i].end_month;
      }
      if (item[i].makeApiCall) {
        trackDetailsObject['makeApiCall'] = true;
        if (item[i]?.bolt_rejected) {
          trackDetailsObject['bolt_rejected'] = true;
        }
      }
      if (item[i].type && item[i].type === 'status') {
        trackDetailsObject['status'] = item[i].status;
      }
      if (item[i].ref_id) {
        trackDetailsObject['refId'] = item[i].ref_id;
      }
      if (item[i].wallet_ref_id) {
        trackDetailsObject['walletRefId'] = item[i].wallet_ref_id;
      }
      if (item[i].remarks) {
        trackDetailsObject['remarks'] = item[i].remarks;
      }
      if (item[i].system_remarks) {
        trackDetailsObject['systemRemarks'] = item[i].system_remarks;
      }
      if (item[i].invoice_url) {
        trackDetailsObject['invoiceUrl'] = item[i].invoice_url;
      }
    }
    if (trackDetailsObject['makeApiCall']) {
      const startDate = format(parseISO(trackDetailsObject?.startMonth), 'yyyy-MM-dd');
      const endDate = format(parseISO(trackDetailsObject?.endMonth), 'yyyy-MM-dd');
      const dateObject = {
        end_date: endDate,
        start_date: startDate,
      };

      const bolt_rejected = trackDetailsObject['bolt_rejected'] || false;

      getCommissionData(dateObject, true, bolt_rejected);
    } else {
      onActionBtnClick(trackDetailsObject, item);
    }
  };

  return (
    <DataTable width="100%" cellPadding="0" cellSpacing="0">
      <thead>
        <tr>
          {monthWiseBreakup?.length &&
            monthWiseBreakup[0].map((item, idx) => {
              return (
                <th key={idx} width={item?.width}>
                  {item?.label && <p className="fs14 latoBold">{item.label}</p>}
                  {item.subLabel && <p className="fs12 fw100 latoRegular mt5">{item.subLabel}</p>}
                </th>
              );
            })}
        </tr>
      </thead>
      <tbody>
        {monthWiseBreakup?.length &&
          monthWiseBreakup.slice(1).map(
            (item, index) =>
              item?.length && (
                <tr key={index}>
                  {item.map(
                    (itm, idx) =>
                      !itm.hideKey && (
                        <td key={idx}>
                          {(itm.start_month || itm.end_month) && (
                            <p className="fs14 blackText flex hCenter">
                              {itm.start_month && (
                                <span className="noShrink">{itm.start_month}</span>
                              )}
                              {itm.end_month && (
                                <>
                                  <span className="mgPd ml3"> {'-'}</span>
                                  <span className="mgPd mr3">{'>'}</span>
                                </>
                              )}
                              {itm.end_month && <span className="noShrink">{itm.end_month}</span>}
                            </p>
                          )}
                          {itm.type !== 'status' && itm.type !== 'click' && itm?.label && (
                            <p className="fs14 blackText">
                              {itm?.type === 'currency' ? '₹ ' : ''}
                              {itm.label !== '' || itm.label !== null ? itm.label : '--'}
                            </p>
                          )}
                          {itm.type === 'status' && (
                            <StatusTag status={itm.label}>{itm.label}</StatusTag>
                          )}
                          {itm.type === 'click' && (
                            <a
                              onClick={() => extractModalDataFromSelectedItem(item)}
                              className="fs12 latoBlack blueText"
                            >
                              {itm.label}
                            </a>
                          )}
                        </td>
                      ),
                  )}
                </tr>
              ),
          )}
      </tbody>
    </DataTable>
  );
};

export default Table;
